import {Injectable} from "@angular/core";
import {
	ALWAYS_ON_FEEDBACK_FORM_ID,
	MEDALLIA_ADD_LOCATION_DISPLAY_SURVEY_PARAMETER_NAME,
	MEDALLIA_CONTACT_FORM_DISPLAY_SURVEY_PARAMETER_NAME,
	MEDALLIA_DASHBOARD_DISPLAY_SURVEY_PARAMETER_NAME,
	MEDALLIA_SURVEY_ENVIRONMENT_PARAMETER_NAME,
	SURVEY_DELAY
} from "../constants/survey.constants";
import {StorageService} from "./storage.service";
import {ToasterNotificationService} from "../components/toaster/services";
import {SurveyEnum} from "../enums/survey.enum";

declare const KAMPYLE_ONSITE_SDK: any;

@Injectable({
	providedIn: "root"
})
export class SurveyService {

	constructor(private readonly storageService: StorageService,
	            private readonly toasterNotificationService: ToasterNotificationService) {
		if (this.isMedalliaAvailable) {
			console.error("Medallia is not available.");
		}
		this.initSurveyVariables();
	}

	private initSurveyVariables(): void {
		this.storageService.storeData(MEDALLIA_CONTACT_FORM_DISPLAY_SURVEY_PARAMETER_NAME, false);
		this.storageService.storeData(MEDALLIA_ADD_LOCATION_DISPLAY_SURVEY_PARAMETER_NAME, false);
		this.storageService.storeData(MEDALLIA_DASHBOARD_DISPLAY_SURVEY_PARAMETER_NAME, false);
	}

	public setSurveyEnvironmentParameter(value: string): void {
		this.storageService.storeData(MEDALLIA_SURVEY_ENVIRONMENT_PARAMETER_NAME, value);
	}

	public updateSurveyVariable(surveyEnum: SurveyEnum, value: boolean): void {
		setTimeout(() => {
			switch (surveyEnum) {
				case SurveyEnum.CONTACT_FORM:
					this.storageService.storeData(MEDALLIA_CONTACT_FORM_DISPLAY_SURVEY_PARAMETER_NAME, value);
					break;
				case SurveyEnum.ADD_LOCATION:
					this.storageService.storeData(MEDALLIA_ADD_LOCATION_DISPLAY_SURVEY_PARAMETER_NAME, value);
					break;
				case SurveyEnum.DASHBOARD:
					this.storageService.storeData(MEDALLIA_DASHBOARD_DISPLAY_SURVEY_PARAMETER_NAME, value);
					break;
			}
			if (value) {
				KAMPYLE_ONSITE_SDK.updatePageView();
				this.updateSurveyVariable(surveyEnum, false);
			}
		}, SURVEY_DELAY);
	}

	public triggerSurvey(): void {
		if (this.isMedalliaAvailable) {
			KAMPYLE_ONSITE_SDK.showForm(ALWAYS_ON_FEEDBACK_FORM_ID);
		} else {
			this.toasterNotificationService.pushErrorNotification("Something went wrong", "Could not open the feedback form.");
		}
	}

	private get isMedalliaAvailable(): boolean {
		return typeof KAMPYLE_ONSITE_SDK !== "undefined";
	}
}

